import { inject, Injectable } from '@angular/core'
import { PreloadingStrategy, Route } from '@angular/router'
import { EMPTY, Observable } from 'rxjs'
import Keycloak from 'keycloak-js'

@Injectable({
	providedIn: 'root',
})
export class RolesBasedPreloadingStrategy implements PreloadingStrategy {
	keycloakService = inject(Keycloak)

	preload(route: Route, fn: () => Observable<any>): Observable<any> {
		if (!route.data?.['preload']) {
			return EMPTY
		}

		const roles: string[] | undefined = route.data?.['roles']
		const hasNoRoleRestriction = !roles || roles.length === 0 || roles.every(r => r === '')

		if (hasNoRoleRestriction || roles.some((role: string) => this.keycloakService.hasRealmRole(role))) {
			return fn()
		}

		return EMPTY
	}
}
